"use strict";
var Observable_1 = require('../../Observable');
var debounce_1 = require('../../operator/debounce');
Observable_1.Observable.prototype.debounce = debounce_1.debounce;
//# sourceMappingURL=debounce.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/add/operator/debounce.js